import { NAME } from './constants';

export const SHIPPERS_FETCH = `${NAME}/SHIPPERS_FETCH`;
export const SHIPPERS_FETCHED = `${NAME}/SHIPPERS_FETCHED`;
export const FETCH = `${NAME}/FETCH`;
export const FETCHED = `${NAME}/FETCHED`;
export const GENERATE = `${NAME}/GENERATE`;
export const GENERATED = `${NAME}/GENERATED`;
export const DOWNLOAD = `${NAME}/DOWNLOAD`;
export const DOWNLOADED = `${NAME}/DOWNLOADED`;
export default {
  SHIPPERS_FETCH,
  SHIPPERS_FETCHED,
  FETCH,
  FETCHED,
  GENERATE,
  GENERATED,
  DOWNLOAD,
  DOWNLOADED,
};
